import { useQuery } from "@tanstack/react-query";

const BASE = process.env.REACT_APP_BACKEND_URL;
const DEFAULTS = { products: true, consultation_packs: true, ebooks: true };

export const SHOP_SECTIONS = [
    { key: "products", type: "product", label: "Supplements", eyebrow: "Formulations" },
    { key: "consultation_packs", type: "consultation_pack", label: "Consultation Packs", eyebrow: "Guided care" },
    { key: "ebooks", type: "ebook", label: "Ebooks & Guides", eyebrow: "Digital library" },
];

// Which shop sections the super admin has switched on (CRM → Settings).
export function useShopSections() {
    const { data } = useQuery({
        queryKey: ["site-appearance-public"],
        queryFn: async () => (await fetch(`${BASE}/api/site/appearance`)).json(),
        staleTime: 120000,
    });
    return { ...DEFAULTS, ...(data?.shop_sections || {}) };
}

export const shopTypeOf = (p) => p.shop_type || "product";
